import { LoadType } from '@tencent/ark-extensions';

/**
 * 支持所有移动端h5页面，引导至客户端的弹窗，同时顶部栏的点击也会引导至客户端
 * 最初只支持wxH5, 导致组件名有歧义。
 */
export default {
    name: 'docs-component-wx-h5-launch',
    loadType: LoadType.ON_DEMAND,
};
